export default "__VITE_ASSET__D9XdF3wC__"